import React, { Component } from "react"

/* Components */
import { InnerLayout } from "../../components"

/* Modal */
import Modal from "react-modal"

/* Switch */
import Switch from "react-switch"

/* Helpers */
import { utils } from "../../helpers"

/* Sweet alert */
import Swal from "../../helpers/alert"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { operators, connect as connectJackpot } from "../../api/Bonus"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Icons */
import { CloseIcon, LinkIcon, JackpotIcon, SafeIcon, EyeIcon, OperatorIcon, CheckIcon, SearchIcon, InfoIcon } from "./BonusIcons"

/* Utils */
import { formatAmount, parseAmount } from "./BonusUtils"


/* HOW MANY OPERATORS TURN THE LIST INTO A SEARCHABLE ONE */
const SEARCHABLE = 8


/* Widget Jackpot Connect */
class JackpotConnect extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: [],
            search: "",
            live: 0,
            operatorID: 0,
            jackpot: "0",
            score: "0",
            enabled: false,
            testersOnly: true,
            waiting: false,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load action */
    load = () => {
        operators().then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [] })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })
    }

    /* Operators Of The List — an operator already carrying a jackpot stays visible but locked */
    getOperators = () => {

        /* Fields */
        const { data, search } = this.state
        const value = search.trim().toLowerCase()

        /* Check Search */
        if (value === "") {
            return data
        }

        /* Send Result */
        return data.filter((item) => String(item.name ? item.name : "").toLowerCase().includes(value))
    }

    /* Оператор уже держит джекпот выбранного пула — второй такой же не заводим */
    isConnected = (item) => {

        /* Fields */
        const { live } = this.state

        /* Send Result */
        return parseInt(live) === 1 ? parseInt(item.live) === 1 : parseInt(item.electron) === 1
    }

    /* Select Pool — при смене пула снимаем выбор, если там оператор уже подключён */
    selectPool = (live) => {

        /* Fields */
        const { data, operatorID } = this.state

        /* Get Operator */
        const item = data.find((row) => row.id === operatorID)

        /* Check Operator */
        const isBusy = item ? (parseInt(live) === 1 ? parseInt(item.live) === 1 : parseInt(item.electron) === 1) : false

        /* Select */
        this.setState({ live, operatorID: isBusy ? 0 : operatorID })
    }

    /* Select Operator */
    selectOperator = (item) => {

        /* Check Operator — one operator keeps one jackpot per pool */
        if (this.isConnected(item)) {
            return
        }

        /* Select */
        this.setState({ operatorID: item.id })
    }

    /* Connect */
    connect = () => {

        /* Fields */
        const { operatorID, live, jackpot, score, enabled, testersOnly } = this.state
        const { close } = this.props

        /* Check Operator */
        if (operatorID === 0) {
            Swal.fire(utils.notification(t("bns.selectOperator"), "warning"))
            return
        }

        /* Fields */
        const jackpotTotal = parseAmount(jackpot)
        const scoreTotal = parseAmount(score)

        /* Waiting */
        this.setState({ waiting: true })

        /* Connect */
        connectJackpot({ operatorID, live, jackpot: jackpotTotal, score: scoreTotal, enabled: enabled ? 1 : 0, testersOnly: testersOnly ? 1 : 0 }).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("swal.savedSuccess"), "success"))
                close()
            }
            else {
                Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })
    }

    /* Draw One Amount */
    _field = (icon, label, value, key) => {

        return (
            <div className="bns--field">

                <div className="bns--field-label">
                    {icon}
                    {label}
                </div>

                <div className="bns--field-input">
                    <span className="bns--field-sign">$</span>
                    <input
                        value={value}
                        onChange={(event) => this.setState({ [key]: formatAmount(event.target.value) })}
                        inputMode="decimal"
                        placeholder="0"
                    />
                </div>

            </div>
        )
    }

    /* Draw Operators */
    _operators = () => {

        /* Fields */
        const { data, search, operatorID } = this.state
        const list = this.getOperators()
        const free = data.filter((item) => !this.isConnected(item)).length

        return (
            <div className="bns--section">

                <div className="bns--section-head">

                    <div className="bns--section-title">
                        <OperatorIcon />
                        {t("bns.operators")}
                        <span className={`bns--counter ${operatorID === 0 ? "empty" : ""}`}>{operatorID === 0 ? 0 : 1}</span>
                    </div>

                </div>

                {data.length > SEARCHABLE &&
                    <div className="bns--inner-search">
                        <SearchIcon size={14} />
                        <input value={search} onChange={(event) => this.setState({ search: event.target.value })} placeholder={t("bns.searchByOperator")} />
                        {search !== "" &&
                            <div onClick={() => this.setState({ search: "" })} className="bns--inner-search-clear">
                                <CloseIcon size={11} />
                            </div>
                        }
                    </div>
                }

                {list.length === 0 &&
                    <div className="bns--chips-empty">{search !== "" ? t("bns.nothingFound") : t("bns.operatorsEmpty")}</div>
                }

                <div className="bns--tables">
                    {list.map((item, index) =>
                        <div
                            onClick={() => this.selectOperator(item)}
                            className={`bns--table-chip ${operatorID === item.id ? "active" : ""} ${this.isConnected(item) ? "locked" : ""}`}
                            key={`${index}`}
                        >

                            <div className="bns--table-box">{operatorID === item.id && <CheckIcon size={11} />}</div>

                            <div className="bns--table-text">
                                <div className="bns--table-name">{utils.checkValue(item.name, "—")}</div>
                                <div className="bns--table-note">{this.isConnected(item) ? t("bns.operatorConnected") : t("bns.operatorFree")}</div>
                            </div>

                        </div>
                    )}
                </div>

                {free === 0 && data.length > 0 &&
                    <div className="bns--hint">
                        <InfoIcon />
                        <span>{t("bns.allConnected")}</span>
                    </div>
                }

            </div>
        )
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, live, jackpot, score, enabled, testersOnly } = this.state

        /* Layout */
        if (status !== "ok") {
            return <InnerLayout status={status} reload={() => this.load()} />
        }

        return (
            <div>

                {/* Draw Pool — живые игры копят джекпот отдельно от электронных */}
                <div className="bns--section">

                    <div className="bns--section-head">
                        <div className="bns--section-title">
                            <JackpotIcon />
                            {t("bns.pool")}
                        </div>
                    </div>

                    <div className="bns--tables">

                        <div onClick={() => this.selectPool(0)} className={`bns--table-chip ${parseInt(live) === 0 ? "active" : ""}`}>
                            <div className="bns--table-box">{parseInt(live) === 0 && <CheckIcon size={11} />}</div>
                            <div className="bns--table-text">
                                <div className="bns--table-name">{t("bns.poolElectron")}</div>
                            </div>
                        </div>

                        <div onClick={() => this.selectPool(1)} className={`bns--table-chip ${parseInt(live) === 1 ? "active" : ""}`}>
                            <div className="bns--table-box">{parseInt(live) === 1 && <CheckIcon size={11} />}</div>
                            <div className="bns--table-text">
                                <div className="bns--table-name">{t("bns.poolLive")}</div>
                            </div>
                        </div>

                    </div>

                </div>

                {/* Draw Operators */}
                {this._operators()}

                {/* Draw Amounts */}
                <div className="bns--section">

                    <div className="bns--section-head">
                        <div className="bns--section-title">
                            <JackpotIcon />
                            {t("bns.startAmounts")}
                        </div>
                    </div>

                    <div className="bns--fields">
                        {this._field(<JackpotIcon size={12} />, "JACKPOT", jackpot, "jackpot")}
                        {this._field(<SafeIcon size={12} />, t("bns.cash"), score, "score")}
                    </div>

                    <div className={`bns--toggle ${enabled ? "active" : ""}`}>

                        <div className="bns--toggle-icon">
                            <EyeIcon size={15} />
                        </div>

                        <div className="bns--toggle-text">
                            <div className="bns--toggle-title">{t("bns.visibility")}</div>
                            <div className="bns--toggle-note">{enabled ? t("bns.visibilityOn") : t("bns.visibilityOff")}</div>
                        </div>

                        <Switch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor="#66bb6a"
                            height={22}
                            width={44}
                            handleDiameter={16}
                            onChange={(value) => this.setState({ enabled: value })}
                            checked={enabled}
                        />

                    </div>

                    {/* Обкатка пула — на старте включена, чтобы новый джекпот не открылся игрокам сразу */}
                    <div className={`bns--toggle ${testersOnly ? "active" : ""}`}>

                        <div className="bns--toggle-icon">
                            <OperatorIcon size={15} />
                        </div>

                        <div className="bns--toggle-text">
                            <div className="bns--toggle-title">{t("bns.testersOnly")}</div>
                            <div className="bns--toggle-note">{testersOnly ? t("bns.testersOnlyOn") : t("bns.testersOnlyOff")}</div>
                        </div>

                        <Switch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor="#ffa726"
                            height={22}
                            width={44}
                            handleDiameter={16}
                            onChange={(value) => this.setState({ testersOnly: value })}
                            checked={testersOnly}
                        />

                    </div>

                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, close } = this.props
        const { status, operatorID, waiting } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => close()}
                className="bns--modal small"
                overlayClassName="bns--overlay"
                closeTimeoutMS={200}
            >

                <div className="bns--modal-header">

                    <div className="bns--modal-icon gold">
                        <LinkIcon size={18} />
                    </div>

                    <div className="bns--modal-head-text">
                        <h2>{t("bns.connectTitle")}</h2>
                        <p>{t("bns.connectSubtitle")}</p>
                    </div>

                    <div onClick={() => close()} className="bns--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="bns--modal-body">
                    {this._content()}
                </div>

                <div className="bns--modal-footer">

                    <div className="bns--modal-footer-right">
                        <div onClick={() => close()} className="bns--button ghost">{t("common.cancel")}</div>
                        <div
                            onClick={() => !waiting && this.connect()}
                            className={`bns--button primary ${waiting ? "waiting" : ""} ${status !== "ok" || operatorID === 0 ? "disabled" : ""}`}
                        >
                            {waiting ? <LoadingOutlined /> : t("bns.connect")}
                        </div>
                    </div>

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(JackpotConnect)
